export default {
  "content": "<rect x=\".5\" y=\".5\" width=\"39\" height=\"25\" rx=\"3.5\" fill=\"#F6F6F9\" stroke=\"#EBEBF0\"/><rect x=\"3.902\" y=\"17.457\" width=\"19.512\" height=\"1.94\" rx=\".5\" fill=\"#C9CBD4\"/><rect x=\"4\" y=\"14\" width=\"6\" height=\"2\" rx=\".5\" fill=\"#C9CBD4\"/><rect x=\"11\" y=\"14\" width=\"6\" height=\"2\" rx=\".5\" fill=\"#C9CBD4\"/><rect x=\"18\" y=\"14\" width=\"6\" height=\"2\" rx=\".5\" fill=\"#C9CBD4\"/><rect x=\"25\" y=\"14\" width=\"6\" height=\"2\" rx=\".5\" fill=\"#C9CBD4\"/>",
  "attrs": {
    "width": "40",
    "height": "26",
    "viewBox": "0 0 40 26",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};